/* eslint-disable react/forbid-prop-types, react/require-default-props */
import React from "react";
import PropTypes from "prop-types";
import GmbGem from "./GmbGem";
import "./spinner.css";

const SIZE_MAP = { inline: 18, section: 48, page: 120 };
const COLOR_MAP = { primary: "#EE238A", white: "#FFFFFF" };

/**
 * Shared indeterminate loading indicator (the animated brand gem). Use
 * `overlay` for a veil over the nearest positioned ancestor (replaces
 * CardBusy's bespoke cs-busy markup). `color` accepts "primary"/"white" or
 * any CSS color string (e.g. "var(--gmb-primary, #1b598e)" for widgets that
 * should follow a company's own brand color instead of GMB's).
 */
const Spinner = ({
  size = "inline",
  color = "primary",
  label = "Loading…",
  overlay = false,
  className = "",
  style = {},
}) => {
  const px = typeof size === "number" ? size : SIZE_MAP[size] || SIZE_MAP.inline;
  const resolvedColor = COLOR_MAP[color] || color;

  const content = (
    <span
      className={`gmb-spinner ${className}`}
      style={style}
      role="status"
      aria-label={label}
    >
      <GmbGem size={px} color={resolvedColor} />
      <span className="gmb-spinner-sr-only">{label}</span>
    </span>
  );

  if (!overlay) return content;

  return (
    <span className="gmb-spinner-overlay" aria-busy="true">
      {content}
    </span>
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["inline", "section", "page"]),
    PropTypes.number,
  ]),
  color: PropTypes.string,
  label: PropTypes.string,
  overlay: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Spinner;
